var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.2871C15 13.9463 13.6592 15.2871 12 15.2871C10.3408 15.2871 9 13.9463 9 12.2871C9 10.6279 10.3408 9.28711 12 9.28711C13.6592 9.28711 15 10.6279 15 12.2871Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.7871C15.2468 18.7871 18.2729 17.1533 20.3792 14.3255C21.207 13.2179 21.207 11.3563 20.3792 10.2487C18.2729 7.42095 15.2468 5.78711 12 5.78711C8.75319 5.78711 5.72713 7.42095 3.62085 10.2487C2.79305 11.3563 2.79305 13.2179 3.62085 14.3255C5.72713 17.1533 8.75319 18.7871 12 18.7871Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7202 5.57812L5.28027 18.9968",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.9351521b862d490cf5e0373201de19d1.svg";
export { ForwardRef as ReactComponent };